import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import classnames from 'classnames';
import { get } from 'lodash';
import { getInitials, stringToColor } from 'ui-utils';

import { UserBase } from '@lib/resources/types';
import configService from '@lib/services/configService';
import storageService from '@lib/services/storageService';

import { LumaTheme } from '../styles/getTheme';

const styles = (theme: LumaTheme) => {
  const {
    spacing: { unit },
    palette: {
      common: { white, black },
    },
  } = theme;

  return {
    avatar: {
      color: white,
      fontSize: '0.85rem',
      fontWeight: 500,
    },
    normal: {
      height: 31,
      width: 31,
    },
    personIcon: {
      color: black,
      fontSize: 22,
    },
    small: {
      height: '26px !important',
      width: '26px !important',
    },
    large: {
      fontSize: '1.15rem',
      height: unit * 5,
      width: unit * 5,
    },
    xlarge: {
      fontSize: '1.15rem',
      height: unit * 8,
      width: unit * 8,
    },
  };
};

interface Props {
  classes: any;
  className?: string;
  user?: UserBase | boolean;
  size?: 'default' | 'small' | 'large' | 'xlarge';
}

const UserAvatar: React.FC<Props> = ({ classes, className, user, size = 'default' }) => {
  const firstAndLastNames = `${get(user, 'firstname', '')} ${get(user, 'lastname', '')}`;
  const initials = getInitials(firstAndLastNames);
  const backgroundColor = stringToColor(initials);
  const content = user ? initials : <PersonIcon classes={{ root: classes.personIcon }} />;
  const avatar = get(user, 'avatar');
  let srcAvatar = get(user, '$srcAvatar');
  if (!srcAvatar && avatar) {
    const token = storageService.getToken();
    srcAvatar = `${configService.getApiBasePath()}/fileUploads/${avatar}/file?token=${token}`;
  }

  return (
    <Avatar
      className={classnames(
        classes.avatar,
        classes.normal,
        {
          [classes.small]: size === 'small',
          [classes.large]: size === 'large',
          [classes.xlarge]: size === 'xlarge',
        },
        className,
      )}
      src={srcAvatar}
      style={{ backgroundColor: initials ? backgroundColor : 'initial' }}
    >
      {content}
    </Avatar>
  );
};

export default withStyles(styles)(UserAvatar);
